export default __webpack_public_path__ + "img/7bb230ef8d99d33ff8221e07f17b32a0.png";